// import layanan
import Btb from "./assets/btb.svg";
import Lab from "./assets/lab.svg";
import Izo from "./assets/izo.svg";

import family from "./assets/family.svg";
import mortar from "./assets/mortarboard.svg";
import mosque from "./assets/mosque.svg";
import steth from "./assets/stethoscope.svg";

import bantuan from "./assets/bantuan.png";

import bp1 from "./assets/bp1.png"
import bp2 from "./assets/bp2.png"
import bp3 from "./assets/bp3.png"
import bp4 from "./assets/bp4.png"

import bs1 from "./assets/bs1.png"
import bs2 from "./assets/bs2.png"
import bs3 from "./assets/bs3.png"
import bs4 from "./assets/bs4.png"

import bc1 from "./assets/bc1.png"
import bc2 from "./assets/bc2.png"
import bc3 from "./assets/bc3.png"
import bc4 from "./assets/bs3.png"

import bse1 from "./assets/bse1.png"
import bse2 from "./assets/bse2.png"
import bse3 from "./assets/bse3.png"
import bse4 from "./assets/bse4.png"

import bt1 from "./assets/bt1.png"
import bt2 from "./assets/bt2.png"
import bt3 from "./assets/bt3.png"
import bt4 from "./assets/bt4.png"

import LAB1 from "./assets/LAB1.png"
import LAB2 from "./assets/LAB2.png"
import LAB3 from "./assets/LAB3.png"
import LAB4 from "./assets/LAB4.png"

import BTB1 from "./assets/BTB1.png"
import BTB2 from "./assets/BTB2.png"
import BTB3 from "./assets/BTB3.png"
import BTB4 from "./assets/BTB4.png"

// navigation
export const navigation = [
  {
    name: "Beranda",
    href: "/",
  },
  {
    name: "Profil",
    href: "/profil",
  },
  {
    name: "Kegiatan",
    href: "/kegiatan",
  },
  {
    name: "Daftar UPZ",
    href: "/daftarUPZ",
  },
  {
    name: "Muzaki",
    href: "/muzaki",
  },
  {
    name: "Mustahiq",
    href: "/mustahiq",
  },
  {
    name: "Laporan",
    href: "/laporan",
  },
];

export const layanan = [
  {
    judul: "BAZNAS Tanggab Bencana",
    image: Btb,
    deskripsi: "Layanan respon tanggap bencana dan recovery pasca bencana",
  },
  {
    judul: "Layanan Aktif Baznas",
    image: Lab,
    deskripsi:
      "Layanan cepat dalam merespon masalah kedaruratan sosial dan kesehatan",
  },
  {
    judul: "BAZNAS Tanggab Bencana",
    image: Izo,
    deskripsi:
      "Muzaki/munfiq dapat melakuka transfer atau setor tunai ke rekening penampung BAZNAS kabupaten Banyumas",
  },
];

// kegiatan
export const kegiatan = [
  {
    image: steth,
    title: "Kesehatan",
    desc: "Sentra Kesehatan dengan tujuan untuk membentuk Sentra Kesehatan sesuai dengan kasus terbanyak dalam komunitas di Banyumas, menjalin kemitraan dengan pihak-pihak terkait dalam penanganan kasus terbanyak, melakukan pelayanan di Sentra Kesehatan secara promotif, preventif dan kuratif. Ayo gotong royong bersama membangun #BetterBanyumas.",
  },
  {
    image: family,
    title: "Keluarga",
    desc: "Bantu sejahterakan keluarga dhuafa dengan sedekah terbaikmu. Yuk peduli berinisiatif merealisasikan program Baznas untuk kaum dhuafa demi menghidupi keseharian mereka yang membutuhkan uluran tangan kita. Donasi yang terkumpul, akan digunakan untuk memenuhi kebutuhan sehari-hari.",
  },
  {
    image: mortar,
    title: "Pendidikan",
    desc: "Donasimu selamatkan generasi bangsa dari putus sekolah. Cukup sisihkan sebagian dari yang kamu miliki untuk berikan support berupa dana pendidikan kepada anak Dhuafa dan Yatim Dhuafa yang terancam putus sekolah dalam program Beasiswa Baznas. Beasiswa diberikan untuk siswa/mahasiswa yang sedang menempuh pendidikan di Kabupaten Banyumas.",
  },
  {
    image: mosque,
    title: "Religi",
    desc: "Sedekah untuk membangun fasilitas keagamaan dan sosial yang lebih baik dan mudah dijangkau oleh masyarakat di Banyumas. Kami berharap Anda adalah #OrangBaik yang menjaga dan menggunakan Baznas Banyumas secara bertanggung jawab dengan semangat menyalurkan kebaikan dan menumbuhkan semangat gotong-royong bagi para #OrangBaik lainnya.",
  },
];

export const berita = [
  {
    text: "Program Benah Rumah, PKK Cilacap Gandeng Baznas",
    image: bantuan,
  },
  {
    text: "Program Benah Rumah, PKK Cilacap Gandeng Baznas",
    image: bantuan,
  },
  {
    text: "Program Benah Rumah, PKK Cilacap Gandeng Baznas",
    image: bantuan,
  },
];

export const banyumasPeduli = [
  {
    image: bp1,
  },
  {
    image: bp2,
  },
  {
    image: bp3,
  },
  {
    image: bp4,
  },
];

export const banyumasSejahtera = [
  {
    image: bs1,
  },
  {
    image: bs2,
  },
  {
    image: bs3,
  },
  {
    image: bs4,
  },
];

export const banyumasCerdas= [
  {
    image: bc1,
  },
  {
    image: bc2,
  },
  {
    image: bc3,
  },
  {
    image: bc4,
  },
];

export const banyumasSehat= [
  {
    image: bse1,
  },
  {
    image: bse2,
  },
  {
    image: bse3,
  },
  {
    image: bse4,
  },
];

export const banyumasTaqwa= [
  {
    image: bt1,
  },
  {
    image: bt2,
  },
  {
    image: bt3,
  },
  {
    image: bt4,
  },
];



export const upz = [
  {
    no: 1,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 2,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 3,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 4,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 5,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 6,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 7,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 8,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 9,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
  {
    no: 10,
    dinas: "Dinas",
    alamat: "Alamat",
    pengelola: "Pengelola"
  },
];

export const LABs = [
  {
    image: LAB1,
  },
  {
    image: LAB2,
  },
  {
    image: LAB3,
  },
  {
    image: LAB4,
  },
];

export const BTBs = [
  {
    image: BTB1,
  },
  {
    image: BTB2,
  },
  {
    image: BTB3,
  },
  {
    image: BTB4,
  },
];
